<template>
  <SmartLinkItemComponent :id="siteCfg?.system?.id" :component="!siteCfg?.system?.workflow">
    <div class="global-footer">
      <div class="container">
        <div class="primary-section">
          <div class="brand">
            <SmartLinkStandaloneElement :codename="type.elements.website_logo.codename">
              <NuxtImg
                v-if="firstOrDefault(siteCfg.elements.website_logo.value)"
                :src="siteCfg.elements.website_logo.value[0]!.url"
                class="logo"
                :alt="siteCfg.elements.site_name.value"
              />
            </SmartLinkStandaloneElement>
          </div>
          <div class="nav">
            <ul class="primary-links">
              <NavigationItemComponent
                v-for="(item, i) in siteStore.footerNavigationItems.primary"
                :model="item"
                :index="i"
                :key="i"
              />
            </ul>
            <ul
              class="social-links"
              v-if="siteCfg.elements.twitter_link.value || siteCfg.elements.linkedin_link.value"
            >
              <li v-if="siteCfg.elements.twitter_link.value" class="nav-item">
                <NuxtLink :to="siteCfg.elements.twitter_link.value" class="nav-link">
                  <IconTwitterX />
                </NuxtLink>
              </li>
              <li v-if="siteCfg.elements.linkedin_link.value" class="nav-item">
                <NuxtLink :to="siteCfg.elements.linkedin_link.value" class="nav-link">
                  <IconLinkedIn />
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <hr class="divider" />
        <div class="secondary-section">
          <div class="info">
            <div class="open-text">
              <RichText :value="siteCfg.elements.open_text.value" />
            </div>
            <div class="copyright">
              <p>{{ siteCfg.elements.copyright_text.value }}</p>
            </div>
          </div>
          <div class="nav">
            <ul class="secondary-links">
              <li class="nav-item">
                <div class="trustarc-placeholder" v-html="trustArcBlock"></div>
              </li>
              <NavigationItemComponent
                v-for="(item, i) in siteStore.footerNavigationItems.secondary"
                :model="item"
                :index="i"
                :key="i"
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import { contentTypes } from '~~/app/models'
import RichText from '../rich-texts/RichText.vue'

const type = contentTypes.site_configuration
const siteStore = useSiteStore()
const siteCfg = siteStore.siteConfig
const trustArcBlock = ref('')
trustArcBlock.value = siteStore.siteConfig.elements.trustarc_code.value
</script>
<style lang="scss" scoped>
.trustarc-placeholder {
  align-items: center;
  display: flex;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  padding: 0;
}
</style>
